export default "__VITE_ASSET__3A7EC3nb__"